import { useWebsiteConfigElements } from '@/components/WebsiteConfiguration'

export const OutcomePaperOverarchingOutcomeWarning = () => {
	const { elements: wcConfigElements } = useWebsiteConfigElements()
	return <>{wcConfigElements?.overarchingoutcome_message?.value ?? ''}</>
}
